import React, {useState} from 'react';

import type {Project} from 'rendition-core';
import {defaultStyleGuide} from './constants';
import {Header} from './Header';
import {type StyleGuide as IStyleGuide, useStyleguideData} from './hooks/useStyleguideData';
import {StyleMap} from './StyleMap';

interface Props {
    project: Project;
    setProject: React.Dispatch<React.SetStateAction<Project | undefined>>;
}

export const StyleGuide: React.FC<Props> = ({project, setProject}) => {
    const [styleGuide, setStyleGuide] = useState<IStyleGuide>({
        cssClasses: {...defaultStyleGuide, ...project.cssClasses},
        cssClassMeta: project.cssClassMeta,
    });
    const [previewText, setPreviewText] = useState('Preview Text');
    const [showPreviewText, setShowPreviewText] = useState(true);
    const [selectedClass, setSelectedClass] = useState<string>('h1');

    const {pasteFromClipboard, clipboardEnabled, value, remove, set} = useStyleguideData(styleGuide, selectedClass);

    return (
        <>
            <div className="flex h-full w-full flex-col items-start justify-start gap-12 px-32 py-12">
                <Header
                    setProject={setProject}
                    pasteFromClipboard={pasteFromClipboard}
                    clipboardEnabled={clipboardEnabled}
                    remove={remove}
                    value={value}
                    setStyleGuide={setStyleGuide}
                    previewText={previewText}
                    setPreviewText={setPreviewText}
                    setShowPreviewText={setShowPreviewText}
                    showPreviewText={showPreviewText}
                />
                <StyleMap
                    selectedClass={selectedClass}
                    setSelectedClass={setSelectedClass}
                    styleGuide={value}
                    setStyleGuide={set}
                    showPreviewText={showPreviewText}
                    previewText={previewText}
                />
            </div>
        </>
    );
};
